import googleCertificateExperiments from 'bundles/epic/clients/GoogleCertificate';

import _t from 'i18n!nls/enroll';

export const generateImpressionForFreemiumModelExperiment = ({
  isCourseraPlusLandingPage,
  courseId,
}: {
  isCourseraPlusLandingPage?: boolean;
  courseId?: string;
}) => {
  // Generate impression if on C+ landing page or passing in a courseId from XDP enroll modal
  if (!isCourseraPlusLandingPage && !courseId) {
    return;
  }

  // The C+ landing page doesn't have a courseId to check for exclusion with tag targeting,
  // so just passing in a fake value to make the Epic impression fire
  const courseIdToCheck = isCourseraPlusLandingPage ? 'cplus-landing-page' : courseId!;

  // eslint-disable-next-line camelcase
  googleCertificateExperiments.get('freemiumModelAaTest', { course_id: courseIdToCheck });

  // eslint-disable-next-line camelcase
  googleCertificateExperiments.get('isFreemiumModelEnabled', { course_id: courseIdToCheck });
};

export const isFreemiumModelEnabled = (courseId?: string) => {
  if (!courseId) {
    return false;
  }

  // eslint-disable-next-line camelcase
  return googleCertificateExperiments.preview('isFreemiumModelEnabled', { course_id: courseId });
};

export const useIsEnrolledThroughFreemiumAccess = (courseId?: string) => {
  // TODO replace with actual logic from BE
  return (
    isFreemiumModelEnabled(courseId) &&
    typeof window !== 'undefined' &&
    window.location.search.includes('isEnrolledThroughFreemiumAccess')
  );
};

// TODO update description copies once they are finalized
export const getFreemiumEnrollModalCopy = () => ({
  auditOnly: _t('Preview this course'),
  auditOnlyDescription: _t('You will have access to all course materials except graded items'),
  fullCourseNoCertificate: _t('Preview this course'),
  fullCourseNoCertificateDescription: _t('You will still have access to all course materials for this course'),
});
